module.exports = __webpack_public_path__ + "img/home-edu.15ad98e.jpg";